import registerDialogs from './register-dialogs';

export default {
  registerDialogs,
};
